import { render, staticRenderFns } from "./SettingToggle.vue?vue&type=template&id=7c78d8d6&"
import script from "./SettingToggle.vue?vue&type=script&lang=js&"
export * from "./SettingToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports